export default "__VITE_ASSET__DBsBpCIR__"